module.exports = __webpack_public_path__ + "img/demand_off.e0882fe3.svg";